/**
 * Tiny pretty-printed JSON viewer used for "view raw payload" affordances
 * inside the activity log and config drawer.
 */

import React from 'react';
import { Platform, ScrollView, StyleSheet, Text } from 'react-native';

import { OcppTheme } from './OcppTheme';

const stringify = (value: unknown): string => {
  if (value === undefined || value === null) return '—';
  try {
    return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

const OcppJsonViewer: React.FC<{ value: unknown; maxHeight?: number }> = ({
  value,
  maxHeight = 220,
}) => {
  return (
    <ScrollView style={[styles.frame, { maxHeight }]} contentContainerStyle={styles.contentContainer}>
      <Text style={styles.json} selectable>
        {stringify(value)}
      </Text>
    </ScrollView>
  );
};

export default OcppJsonViewer;

const styles = StyleSheet.create({
  frame: {
    backgroundColor: OcppTheme.surfaceAlt,
    borderRadius: 10,
    padding: 12,
  },
  contentContainer: {
    paddingBottom: 6,
  },
  json: {
    fontFamily: Platform.select({ ios: 'Menlo', android: 'monospace', web: 'monospace' }),
    fontSize: 12,
    color: OcppTheme.textSecondary,
    lineHeight: 18,
  },
});
